import React from 'react';
import { Box, Button, IconButton, Menu, MenuItem, TextField, Tooltip, Typography } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { FINANCE_PRESET, formatPeriodLabel } from '../../utils/finance/financePeriod';
import { fx } from './financeTheme';

const PRIMARY = [
  { id: FINANCE_PRESET.BUGUN, label: 'Bugün' },
  { id: FINANCE_PRESET.BU_HAFTA, label: 'Bu Hafta' },
  { id: FINANCE_PRESET.BU_AY, label: 'Bu Ay' }
];

export default function FinancePeriodSelector({ preset, range, subeLabel, onPreset, customStart, customEnd, onCustom, onPdf, pdfBusy }) {
  const [anchor, setAnchor] = React.useState(null);
  const extraLabel = preset === FINANCE_PRESET.DUN ? 'Dün'
    : preset === FINANCE_PRESET.GECEN_HAFTA ? 'Geçen Hafta'
      : preset === FINANCE_PRESET.GECEN_AY ? 'Geçen Ay'
        : preset === FINANCE_PRESET.BU_YIL ? 'Bu Yıl'
          : preset === FINANCE_PRESET.OZEL ? 'Özel Tarih'
            : null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, minWidth: 0 }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 22, fontWeight: 800, color: fx.text, letterSpacing: '-0.02em', lineHeight: 1.15 }}>
          Finans
        </Typography>
        <Typography sx={{ fontSize: 13, color: fx.muted, mt: 0.3 }}>
          Gelir, maliyet, gider ve kârlılık görünümü
          {subeLabel ? ` · ${subeLabel}` : ''}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexShrink: 0, flexWrap: 'nowrap' }}>
        <Box sx={{ display: 'flex', bgcolor: '#fff', border: `1px solid ${fx.border}`, borderRadius: '10px', p: '3px' }}>
          {PRIMARY.map((item) => (
            <Button
              key={item.id}
              size="small"
              onClick={() => onPreset(item.id)}
              sx={{
                minWidth: 0,
                px: { xs: 1, md: 1.5 },
                py: 0.45,
                fontSize: 13,
                fontWeight: 700,
                textTransform: 'none',
                color: preset === item.id ? fx.text : fx.muted,
                bgcolor: preset === item.id ? fx.primarySoft : 'transparent',
                borderRadius: '8px'
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>
        {onPdf ? (
          <Tooltip title="Bu dönemin finans özetini PDF indir (WhatsApp'a giden raporun aynısı)">
            <span>
              <Button
                size="small"
                onClick={onPdf}
                disabled={pdfBusy}
                sx={{ minWidth: 0, px: 1.25, py: 0.45, fontSize: 13, fontWeight: 700, textTransform: 'none', color: fx.text, border: `1px solid ${fx.border}`, borderRadius: '8px', bgcolor: '#fff' }}
              >
                {pdfBusy ? 'PDF…' : 'PDF'}
              </Button>
            </span>
          </Tooltip>
        ) : null}
        <Tooltip title="Diğer tarihler">
          <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)} aria-label="diğer tarihler" sx={{ border: `1px solid ${fx.border}`, bgcolor: '#fff', borderRadius: '8px' }}>
            <MoreHorizIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
          <MenuItem onClick={() => { onPreset(FINANCE_PRESET.DUN); setAnchor(null); }}>Dün</MenuItem>
          <MenuItem onClick={() => { onPreset(FINANCE_PRESET.GECEN_HAFTA); setAnchor(null); }}>Geçen Hafta</MenuItem>
          <MenuItem onClick={() => { onPreset(FINANCE_PRESET.GECEN_AY); setAnchor(null); }}>Geçen Ay</MenuItem>
          <MenuItem onClick={() => { onPreset(FINANCE_PRESET.BU_YIL); setAnchor(null); }}>Bu Yıl</MenuItem>
          <MenuItem disableRipple sx={{ display: 'block', py: 1.2 }}>
            <Typography sx={{ fontSize: 12, fontWeight: 800, mb: 0.75 }}>Özel Tarih</Typography>
            <Box sx={{ display: 'flex', gap: 0.75 }}>
              <TextField size="small" type="date" value={customStart || ''} onChange={(e) => onCustom({ start: e.target.value })} sx={{ width: 150 }} />
              <TextField size="small" type="date" value={customEnd || ''} onChange={(e) => onCustom({ end: e.target.value })} sx={{ width: 150 }} />
              <Button size="small" onClick={() => { onPreset(FINANCE_PRESET.OZEL); setAnchor(null); }}>Uygula</Button>
            </Box>
          </MenuItem>
        </Menu>
        <Typography sx={{ fontSize: 12.5, color: fx.muted, fontWeight: 600, maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: { xs: 'none', lg: 'block' } }}>
          {extraLabel ? `${extraLabel} · ` : ''}{formatPeriodLabel(range)}
        </Typography>
      </Box>
    </Box>
  );
}
